import { useWindowResize } from 'hooks/use-window-resize';

export const useIframeHeight = (ref, dep) => {
  const { height } = useWindowResize(
    (windowHeight) => {
      const iframe = ref.current;

      if (!iframe) {
        return windowHeight - 185;
      }
      const { top } = iframe.getBoundingClientRect() ?? {};

      return windowHeight - top;
    },
    [dep],
  );

  return height;
};
